/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type GetApiV3ImagesDataCentersDcIdPngRequest = {
  dcId: string;
};

/** @internal */
export const GetApiV3ImagesDataCentersDcIdPngRequest$inboundSchema: z.ZodType<
  GetApiV3ImagesDataCentersDcIdPngRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  dc_id: z.string(),
}).transform((v) => {
  return remap$(v, {
    "dc_id": "dcId",
  });
});

/** @internal */
export type GetApiV3ImagesDataCentersDcIdPngRequest$Outbound = {
  dc_id: string;
};

/** @internal */
export const GetApiV3ImagesDataCentersDcIdPngRequest$outboundSchema: z.ZodType<
  GetApiV3ImagesDataCentersDcIdPngRequest$Outbound,
  z.ZodTypeDef,
  GetApiV3ImagesDataCentersDcIdPngRequest
> = z.object({
  dcId: z.string(),
}).transform((v) => {
  return remap$(v, {
    dcId: "dc_id",
  });
});

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiV3ImagesDataCentersDcIdPngRequest$ {
  /** @deprecated use `GetApiV3ImagesDataCentersDcIdPngRequest$inboundSchema` instead. */
  export const inboundSchema =
    GetApiV3ImagesDataCentersDcIdPngRequest$inboundSchema;
  /** @deprecated use `GetApiV3ImagesDataCentersDcIdPngRequest$outboundSchema` instead. */
  export const outboundSchema =
    GetApiV3ImagesDataCentersDcIdPngRequest$outboundSchema;
  /** @deprecated use `GetApiV3ImagesDataCentersDcIdPngRequest$Outbound` instead. */
  export type Outbound = GetApiV3ImagesDataCentersDcIdPngRequest$Outbound;
}

export function getApiV3ImagesDataCentersDcIdPngRequestToJSON(
  getApiV3ImagesDataCentersDcIdPngRequest:
    GetApiV3ImagesDataCentersDcIdPngRequest,
): string {
  return JSON.stringify(
    GetApiV3ImagesDataCentersDcIdPngRequest$outboundSchema.parse(
      getApiV3ImagesDataCentersDcIdPngRequest,
    ),
  );
}

export function getApiV3ImagesDataCentersDcIdPngRequestFromJSON(
  jsonString: string,
): SafeParseResult<
  GetApiV3ImagesDataCentersDcIdPngRequest,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      GetApiV3ImagesDataCentersDcIdPngRequest$inboundSchema.parse(
        JSON.parse(x),
      ),
    `Failed to parse 'GetApiV3ImagesDataCentersDcIdPngRequest' from JSON`,
  );
}
